import React, { useState } from "react";

const FormulaCard = ({ formulaKey, formulaData }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  return (
    <div
      className="card border-secondary flex-grow-1"
      style={{ minWidth: "300px" }}
    >
      <div
        className="card-header"
        style={{
          background:
            "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 50%, #1e40af 100%)",
          color: "#ffffff",
          padding: "15px",
        }}
      >
        <div className="d-flex flex-column gap-2">
          <div className="fw-bold text-center" style={{ fontSize: "16px" }}>
            {formulaData?.formulaDisplayCol}
          </div>
          <div className="text-center" style={{ fontSize: "13px" }}>
            {formulaKey} = {formulaData?.formulaExpression}
          </div>
          <div className="fw-bold fs-4 text-center p-2 rounded">
            {formulaData?.formulaResult}
          </div>
        </div>
      </div>
      {formulaData?.components?.length > 0 && (
        <div
          className="card-body"
          style={{
            background:
              "linear-gradient(135deg, #efefef 0%, #d3d5da 50%,rgb(218, 226, 243) 100%)",
            padding: "15px",
          }}
        >
          <div className="d-none d-md-block">
            <div className="fw-bold text-muted mb-3">Components</div>
            <div className="d-flex flex-column gap-2">
              {formulaData.components.map((comp, idx) => (
                <div
                  key={idx}
                  className="d-flex justify-content-between align-items-center border-bottom border-light"
                  style={{ minHeight: "40px" }}
                >
                  <div className="d-flex flex-column px-2">
                    <div className="fw-bold">{comp?.metaDisplayCol}</div>
                    <div style={{ fontSize: "14px", color: "blue" }}>
                      {comp?.componentCode}
                    </div>
                  </div>
                  <div className="fw-bold fs-5 px-3 py-1 rounded">
                    {comp?.metaValue}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile view - accordion */}
          <div className="d-md-none">
            <div
              className="fw-bold text-muted mb-3 d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer" }}
              onClick={toggleAccordion}
            >
              <span>Components</span>
              <i
                className={`fas fa-chevron-${isAccordionOpen ? "up" : "down"}`}
                style={{ fontSize: "14px" }}
              ></i>
            </div>
            <div
              className={`accordion-collapse ${isAccordionOpen ? "show" : ""}`}
              style={{
                overflow: "hidden",
                transition: "max-height 0.3s ease-in-out",
                maxHeight: isAccordionOpen ? "1000px" : "0",
              }}
            >
              <div className="d-flex flex-column gap-2">
                {formulaData.components.map((comp, idx) => (
                  <div
                    key={idx}
                    className="d-flex justify-content-between align-items-center border-bottom border-light"
                    style={{ minHeight: "40px" }}
                  >
                    <div className="d-flex flex-column px-2">
                      <div className="fw-bold">{comp?.metaDisplayCol}</div>
                      <div style={{ fontSize: "14px" }}>
                        {comp?.componentCode}
                      </div>
                    </div>
                    <div className="fw-bold fs-5 px-3 py-1 rounded">
                      {comp?.metaValue}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
//#fffc6c
const CombinedFormulaCard = ({ title, formula, result }) => (
  <div
    className="card border-secondary mb-4 p-2"
    style={{
      background:
        "linear-gradient(135deg, #4ade80 0%, #22c55e 50%, #16a34a 100%)",
    }}
  >
    <div className="card-body">
      <div className="row align-items-center">
        <div className="col-12">
          <div
            className="fw-bold text-center"
            style={{
              fontSize: "18px",
              color: "#fff",
              padding: "15px",
              borderRadius: "8px",
            }}
          >
            {title}
          </div>
        </div>
        <div
          className="d-flex flex-row flex-wrap justify-content-between"
          style={{ color: "#fff" }}
        >
          <div>
            <div className="fw-bold mb-2">Combined Formula</div>
            <div className="rounded fw-bold fs-4">{formula}</div>
          </div>
          <div>
            <div className="fw-bold mb-2">Result</div>
            <div className="fw-bold fs-4">{result}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const InnerIncentiveInfoView = ({ innerInfoData }) => {
  const safeData = innerInfoData ?? {};
  const title = Object.keys(safeData)?.[0];
  const data = safeData[title];
  const formulas = data?.formulas;
  const hasData = Object.keys(safeData)?.length !== 0;

  const NoData = () => (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h6 className="text-center">No Data Available!</h6>
    </div>
  );

  return (
    <div className="container mt-1">
      <div className="card position-relative">
        {hasData ? (
          <>
            <div className="card-body">
              <CombinedFormulaCard
                title={title}
                formula={data?.combinedFormula}
                result={data?.combinedFormulaResult}
              />
              <div className="d-flex flex-wrap gap-4">
                {Object.entries(formulas ?? {})?.map(([formulaKey, formulaData]) => (
                  <FormulaCard
                    key={formulaKey}
                    formulaKey={formulaKey}
                    formulaData={formulaData}
                  />
                ))}
              </div>
            </div>
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default InnerIncentiveInfoView;
